export interface IPropertyAddress {
  street_address: string | null;
  unit: string | null;
  city: string | null;
  state: string | null;
  zip_code: string | null;
  countyState: string | null;
  countyName?: string | null;
  countyFips?: string | null;
}
export const createDefaultProperty = (): IPropertyAddress => ({
  street_address: '',
  unit: '',
  city: '',
  state: null,
  zip_code: '',
  countyFips: null,
  countyName: null,
  countyState: null,
});

export const propertyAddressToString = ({
  street_address,
  unit,
  city,
  state,
  zip_code,
}: Pick<IPropertyAddress, 'street_address' | 'city' | 'state' | 'unit' | 'zip_code'>) =>
  `${street_address}${unit ? ` ${unit}` : ''} ${city}, ${state} ${zip_code}`;
